import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';

export interface UpdateConfirmationDialogData {
  type: string;
  originalSlug: string;
  newSlug: string;
  confirmationCallback: () => Observable<null>;
}

@Component({
  selector: 'meeting-scheduler-update-confirmation-dialog',
  templateUrl: './update-confirmation-dialog.component.html',
  styleUrls: ['./update-confirmation-dialog.component.scss'],
  standalone: false,
})
export class UpdateConfirmationDialogComponent implements OnDestroy {
  isUpdating = false;
  private readonly subscriptions: Subscription[] = [];

  constructor(
    private readonly ref: MatDialogRef<UpdateConfirmationDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) readonly data: UpdateConfirmationDialogData,
  ) {}

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onNoClick(): void {
    this.ref.close(false);
  }

  onYesClick(): void {
    this.isUpdating = true;
    const sub = this.data.confirmationCallback().subscribe({
      next: () => this.ref.close(true),
    });
    sub.add(() => (this.isUpdating = false));
    this.subscriptions.push(sub);
  }
}
